export const getEventPointOfInterestSubnav = (projectId: string, pointOfInterestId: string, moodId: string) => [
  {
    title: 'Point of Interest Details',
    to: `/project/${projectId}/mood/${moodId}/event-point-of-interest/${pointOfInterestId}`
  },
  {
    title: 'Translations',
    to: `/project/${projectId}/mood/${moodId}/event-point-of-interest/${pointOfInterestId}/translations`
  },
]
